import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes';

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})
router.afterEach((to, from, next) => {

    window.scrollTo(0, 0);

})


export default router
